// WebSocket Configuration for Selador Real Estate Backend
// 
// Update these values to match your deployed WebSocket API
export function getWebSocketUrl(): string {
  return 'wss://0l4m73rdel.execute-api.us-west-2.amazonaws.com/production';
}

// REST API base (report status, analysis history, etc.).
// Keep this separate from WebSocket API to avoid host mismatch.
export function getRestApiBaseUrl(): string {
  return 'https://8dwpvsptxc.execute-api.us-west-2.amazonaws.com/test';
}

/** @deprecated Use getRestApiBaseUrl */
export function getReportStatusApiUrl(): string {
  return getRestApiBaseUrl();
}

export const WEBSOCKET_CONFIG = {
  URL: getWebSocketUrl(),
  RECONNECT: true,
  RECONNECT_INTERVAL: 2000,
  CONNECTION_TIMEOUT: 10000,
  RECONNECT_ATTEMPTS: 3,
  RECONNECT_DELAY: 1000,
  QUERY_TIMEOUT: 240000,
  TEST_TIMEOUT: 5000,
}; 